import React from "react";
import { Modal, Button } from "react-bootstrap";
import Form from "../Shared/Form";
import { useIntl } from "react-intl"; // لو بتستخدم internationalization

const ContactModal = ({ show, onHide }) => {
  const { formatMessage } = useIntl();

  return (
    <Modal show={show} onHide={onHide} centered className="contact-modal">
      <Modal.Header closeButton>
        <Modal.Title>{formatMessage({ id: "contact" })}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form
        //   formTitle={formatMessage({ id: "toAskService" })}
        //   formSubtitle={formatMessage({ id: "askService" })}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ContactModal;
